import { useEffect } from 'react';
import { toast } from 'sonner';

export const useImageProtection = () => {
  useEffect(() => {
    const handleContextMenu = (e) => {
      // Check if the target is an image
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        
        toast.error(
          '© Todas las imágenes están protegidas por derechos de autor. Queda prohibida su descarga, reproducción o uso sin autorización expresa de Jon Quintano Fotografía.',
          {
            duration: 5000,
            icon: '🔒',
          }
        );
        
        return false;
      }
    };

    // Prevent drag and drop of images
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
        return false;
      }
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, []);
};

export default useImageProtection;
